import * as Types from '@battlefly/__generated__/globalTypes';

import { gql } from '@apollo/client';
import { CorBattleflyFieldsFragmentDoc, CoreHuntersMarkFieldsFragmentDoc, CoreScavengingMarkFieldsFragmentDoc } from './fragments';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserConnectMutationVariables = Types.Exact<{
  input: Types.ConnectInput;
}>;


export type UserConnectMutation = { __typename?: 'Mutation', connect: { __typename?: 'TokenPair', accessToken: string, refreshToken: string } };

export type RefreshTokenMutationVariables = Types.Exact<{
  refreshToken: Types.Scalars['String'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshTokens: { __typename?: 'TokenPair', accessToken: string, refreshToken: string } };

export type GetUserInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, role: string, createdAt: any, updatedAt: any, wallets: Array<{ __typename?: 'Wallet', id: string, address: string, magic: number }> } };

export type BattleflyUserBalancesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BattleflyUserBalancesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, wallets: Array<{ __typename?: 'Wallet', nectar: number, magic: number }>, credits: Array<{ __typename?: 'Credit', type: Types.CreditType, quantity: number }> } };

export type GetBattleFliesByIdsQueryVariables = Types.Exact<{
  battleFlyIds?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type GetBattleFliesByIdsQuery = { __typename?: 'Query', getBattleFlies: Array<{ __typename?: 'GenericBattleFly', id: string, stage: string, cocoon: { __typename?: 'Cocoon', edition: string, appearance: { __typename?: 'BattleFlyAppearance', image: string | null } } | null }> };

export type GetBattleFliesAllDataByIdsQueryVariables = Types.Exact<{
  battleFlyIds?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type GetBattleFliesAllDataByIdsQuery = { __typename?: 'Query', getBattleFlies: Array<{ __typename?: 'GenericBattleFly', id: string, stage: string, cocoon: { __typename?: 'Cocoon', appearance: { __typename?: 'BattleFlyAppearance', image: string | null } } | null, battleFly: { __typename?: 'BattleFly', hyperdomeWins: number, hyperdomeLosses: number, provingGroundsWins: number, provingGroundsLosses: number, id: string, slotsAvailable: number, stage: string, name: string, class: Types.BattleFlyClass | null, edition: string, rarity: Types.Rarity | null, location: Types.BattleFlyLocation, provingGroundsCombatRate: number, hyperdomeCombatRate: number, placeInGlobalLeaderboard: number, age: number, starsRate: number, league: Types.BattleFlyLeague, leagueTier: number, contestPoints: number, level: number | null, combatHistoryPaginated: { __typename?: 'PaginatedCombatLog', edges: Array<{ __typename?: 'CombatLogEdge', node: { __typename?: 'Combat', battleFlyWinner: { __typename?: 'BattleFly', id: string } } }> | null }, traits: Array<{ __typename?: 'Trait', name: string, damageType: string | null, stat: string, value: number, unitType: Types.UnitType, id: string }> | null, appearance: { __typename?: 'BattleFlyAppearance', image: string | null }, mods: Array<{ __typename?: 'Mod', id: string, name: string, damageType: string | null, rarity: string, type: string, effects: any, stats: any, slot: number, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, inventory: Array<{ __typename?: 'Mod', id: string, name: string, damageType: string | null, rarity: string, type: string, effects: any, stats: any, slot: number, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, owner: { __typename?: 'Identity', id: string, user: { __typename?: 'User', id: string, wallets: Array<{ __typename?: 'Wallet', address: string }> } } | null, tattoos: Array<{ __typename?: 'Tattoo', id: string, name: string, amount: number }> } | null }> };

export type GetMyBattleflysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyBattleflysQuery = { __typename?: 'Query', me: { __typename?: 'User', battleFlies: Array<{ __typename?: 'BattleFly', hyperdomeWins: number, hyperdomeLosses: number, provingGroundsWins: number, provingGroundsLosses: number, id: string, slotsAvailable: number, stage: string, name: string, class: Types.BattleFlyClass | null, edition: string, rarity: Types.Rarity | null, location: Types.BattleFlyLocation, provingGroundsCombatRate: number, hyperdomeCombatRate: number, placeInGlobalLeaderboard: number, age: number, starsRate: number, league: Types.BattleFlyLeague, leagueTier: number, contestPoints: number, level: number | null, combatHistoryPaginated: { __typename?: 'PaginatedCombatLog', edges: Array<{ __typename?: 'CombatLogEdge', node: { __typename?: 'Combat', battleFlyWinner: { __typename?: 'BattleFly', id: string } } }> | null }, traits: Array<{ __typename?: 'Trait', name: string, damageType: string | null, stat: string, value: number, unitType: Types.UnitType, id: string }> | null, appearance: { __typename?: 'BattleFlyAppearance', image: string | null }, mods: Array<{ __typename?: 'Mod', id: string, name: string, damageType: string | null, rarity: string, type: string, effects: any, stats: any, slot: number, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, inventory: Array<{ __typename?: 'Mod', id: string, name: string, damageType: string | null, rarity: string, type: string, effects: any, stats: any, slot: number, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, owner: { __typename?: 'Identity', id: string, user: { __typename?: 'User', id: string, wallets: Array<{ __typename?: 'Wallet', address: string }> } } | null, tattoos: Array<{ __typename?: 'Tattoo', id: string, name: string, amount: number }> }> } };


export const UserConnectDocument = gql`
    mutation UserConnect($input: ConnectInput!) {
  connect(input: $input) {
    accessToken
    refreshToken
  }
}
    `;
export type UserConnectMutationFn = Apollo.MutationFunction<UserConnectMutation, UserConnectMutationVariables>;

/**
 * __useUserConnectMutation__
 *
 * To run a mutation, you first call `useUserConnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConnectMutation, { data, loading, error }] = useUserConnectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserConnectMutation(baseOptions?: Apollo.MutationHookOptions<UserConnectMutation, UserConnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserConnectMutation, UserConnectMutationVariables>(UserConnectDocument, options);
      }
export type UserConnectMutationHookResult = ReturnType<typeof useUserConnectMutation>;
export type UserConnectMutationResult = Apollo.MutationResult<UserConnectMutation>;
export type UserConnectMutationOptions = Apollo.BaseMutationOptions<UserConnectMutation, UserConnectMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshTokens(input: {refreshToken: $refreshToken}) {
    accessToken
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const GetUserInfoDocument = gql`
    query GetUserInfo {
  me {
    id
    wallets {
      id
      address
      magic
    }
    role
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
      }
export function useGetUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
        }
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>;
export type GetUserInfoLazyQueryHookResult = ReturnType<typeof useGetUserInfoLazyQuery>;
export type GetUserInfoQueryResult = Apollo.QueryResult<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const BattleflyUserBalancesDocument = gql`
    query BattleflyUserBalances {
  me {
    id
    wallets {
      nectar
      magic
    }
    credits {
      type
      quantity
    }
  }
}
    `;

/**
 * __useBattleflyUserBalancesQuery__
 *
 * To run a query within a React component, call `useBattleflyUserBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBattleflyUserBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBattleflyUserBalancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBattleflyUserBalancesQuery(baseOptions?: Apollo.QueryHookOptions<BattleflyUserBalancesQuery, BattleflyUserBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BattleflyUserBalancesQuery, BattleflyUserBalancesQueryVariables>(BattleflyUserBalancesDocument, options);
      }
export function useBattleflyUserBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BattleflyUserBalancesQuery, BattleflyUserBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BattleflyUserBalancesQuery, BattleflyUserBalancesQueryVariables>(BattleflyUserBalancesDocument, options);
        }
export type BattleflyUserBalancesQueryHookResult = ReturnType<typeof useBattleflyUserBalancesQuery>;
export type BattleflyUserBalancesLazyQueryHookResult = ReturnType<typeof useBattleflyUserBalancesLazyQuery>;
export type BattleflyUserBalancesQueryResult = Apollo.QueryResult<BattleflyUserBalancesQuery, BattleflyUserBalancesQueryVariables>;
export const GetBattleFliesByIdsDocument = gql`
    query GetBattleFliesByIds($battleFlyIds: [ID!]) {
  getBattleFlies(input: {battleFlyIds: $battleFlyIds}) {
    id
    stage
    cocoon {
      appearance {
        image
      }
      edition
    }
  }
}
    `;

/**
 * __useGetBattleFliesByIdsQuery__
 *
 * To run a query within a React component, call `useGetBattleFliesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBattleFliesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBattleFliesByIdsQuery({
 *   variables: {
 *      battleFlyIds: // value for 'battleFlyIds'
 *   },
 * });
 */
export function useGetBattleFliesByIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetBattleFliesByIdsQuery, GetBattleFliesByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBattleFliesByIdsQuery, GetBattleFliesByIdsQueryVariables>(GetBattleFliesByIdsDocument, options);
      }
export function useGetBattleFliesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBattleFliesByIdsQuery, GetBattleFliesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBattleFliesByIdsQuery, GetBattleFliesByIdsQueryVariables>(GetBattleFliesByIdsDocument, options);
        }
export type GetBattleFliesByIdsQueryHookResult = ReturnType<typeof useGetBattleFliesByIdsQuery>;
export type GetBattleFliesByIdsLazyQueryHookResult = ReturnType<typeof useGetBattleFliesByIdsLazyQuery>;
export type GetBattleFliesByIdsQueryResult = Apollo.QueryResult<GetBattleFliesByIdsQuery, GetBattleFliesByIdsQueryVariables>;
export const GetBattleFliesAllDataByIdsDocument = gql`
    query GetBattleFliesAllDataByIds($battleFlyIds: [ID!]) {
  getBattleFlies(input: {battleFlyIds: $battleFlyIds}) {
    id
    stage
    cocoon {
      appearance {
        image
      }
    }
    battleFly {
      ...CorBattleflyFields
      hyperdomeWins
      hyperdomeLosses
      provingGroundsWins
      provingGroundsLosses
      combatHistoryPaginated(first: 5, returnTotalCount: false) {
        edges {
          node {
            battleFlyWinner {
              id
            }
          }
        }
      }
    }
  }
}
    ${CorBattleflyFieldsFragmentDoc}`;

/**
 * __useGetBattleFliesAllDataByIdsQuery__
 *
 * To run a query within a React component, call `useGetBattleFliesAllDataByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBattleFliesAllDataByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBattleFliesAllDataByIdsQuery({
 *   variables: {
 *      battleFlyIds: // value for 'battleFlyIds'
 *   },
 * });
 */
export function useGetBattleFliesAllDataByIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetBattleFliesAllDataByIdsQuery, GetBattleFliesAllDataByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBattleFliesAllDataByIdsQuery, GetBattleFliesAllDataByIdsQueryVariables>(GetBattleFliesAllDataByIdsDocument, options);
      }
export function useGetBattleFliesAllDataByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBattleFliesAllDataByIdsQuery, GetBattleFliesAllDataByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBattleFliesAllDataByIdsQuery, GetBattleFliesAllDataByIdsQueryVariables>(GetBattleFliesAllDataByIdsDocument, options);
        }
export type GetBattleFliesAllDataByIdsQueryHookResult = ReturnType<typeof useGetBattleFliesAllDataByIdsQuery>;
export type GetBattleFliesAllDataByIdsLazyQueryHookResult = ReturnType<typeof useGetBattleFliesAllDataByIdsLazyQuery>;
export type GetBattleFliesAllDataByIdsQueryResult = Apollo.QueryResult<GetBattleFliesAllDataByIdsQuery, GetBattleFliesAllDataByIdsQueryVariables>;
export const GetMyBattleflysDocument = gql`
    query GetMyBattleflys {
  me {
    battleFlies {
      ...CorBattleflyFields
      hyperdomeWins
      hyperdomeLosses
      provingGroundsWins
      provingGroundsLosses
      combatHistoryPaginated(first: 5, returnTotalCount: false) {
        edges {
          node {
            battleFlyWinner {
              id
            }
          }
        }
      }
    }
  }
}
    ${CorBattleflyFieldsFragmentDoc}`;

/**
 * __useGetMyBattleflysQuery__
 *
 * To run a query within a React component, call `useGetMyBattleflysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBattleflysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBattleflysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyBattleflysQuery(baseOptions?: Apollo.QueryHookOptions<GetMyBattleflysQuery, GetMyBattleflysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyBattleflysQuery, GetMyBattleflysQueryVariables>(GetMyBattleflysDocument, options);
      }
export function useGetMyBattleflysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyBattleflysQuery, GetMyBattleflysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyBattleflysQuery, GetMyBattleflysQueryVariables>(GetMyBattleflysDocument, options);
        }
export type GetMyBattleflysQueryHookResult = ReturnType<typeof useGetMyBattleflysQuery>;
export type GetMyBattleflysLazyQueryHookResult = ReturnType<typeof useGetMyBattleflysLazyQuery>;
export type GetMyBattleflysQueryResult = Apollo.QueryResult<GetMyBattleflysQuery, GetMyBattleflysQueryVariables>;